import { useConfig } from '@hooks/UseConfig';
import { ChangePasswordTicket, UserProfile } from '../../types/header/UserProfile';
import { GetOneFromPath, PostWithReturn, PutWithReturn } from '../api/GenericClient';

const initialPath = '/common';

async function getUserProfile(): Promise<UserProfile> {
  const url = '/userprofile';
  const apiPath = initialPath.concat(url);
  return await GetOneFromPath<UserProfile>(apiPath);
}

async function putUserProfile(data: UserProfile): Promise<Response> {
  const url = '/userprofile';
  const apiPath = initialPath.concat(url);
  return await PutWithReturn(apiPath, data);
}

async function getVerifyCurrentUserPassword(userName: string, password: string): Promise<Response> {
  const body = { userName: userName, password: password };
  const url = `/users/verifyUserCurrentPassword`;
  return PostWithReturn(url, body);
}

async function generateAndSendOtpSms(recipient: string): Promise<Response> {
  const body = { recipient };
  const url = '/generateandsendsms';
  const apiPath = initialPath.concat(url);
  return await PostWithReturn(apiPath, body);
}

async function validateOtp(
  otpVerificationToken: string,
  otpCode: string,
  email?: string,
): Promise<Response> {
  const body = { email, token: otpVerificationToken, otpCode };
  const url = '/validatesms';
  const apiPath = initialPath.concat(url);
  return await PostWithReturn(apiPath, body);
}

async function getChangePasswordTicket(): Promise<ChangePasswordTicket> {
  const { clientId } = useConfig();
  const url = `/users/changePasswordTicket?clientId=${clientId}`;
  return await GetOneFromPath<ChangePasswordTicket>(url);
}

export const UsersService = {
  getUserProfile,
  putUserProfile,
  getVerifyCurrentUserPassword,
  generateAndSendOtpSms,
  validateOtp,
  getChangePasswordTicket,
};
